import React, { useState } from 'react';

import { DatasourceModel, DatasourceType, jFolderList, WidgetTableColumnsData } from 'jamespot-user-api';

import { JRCFolders } from 'components/JRCFolders/JRCFolders';

import { JRCButton } from 'components/JRCButton/JRCButton';
import { JRCModalContent } from 'components/JRCModal/JRCModalContent';
import { JRCModalLayout } from 'components/JRCModal/JRCModalLayout';
import { useEditorContext } from 'components/Widgets/context/hooks';
import { useIntl } from 'react-intl';
import { WidgetDatasourceModelView } from '../../components/WidgetDatasourceModelView';
import { DATASOURCE_TYPE, SUPPORTED_DISPLAY_TYPE } from '../../const';
import { WidgetDatasourceContext } from '../../JRCWidgetDatasourceTableEditor';
import { DocEditorObject } from './DocEditorObject';

export const DocEditor = ({
    uri,
    tableColumnsData,
    model,
    type,
}: {
    uri?: string;
    model?: DatasourceModel;
    type?: DatasourceType;
    tableColumnsData: WidgetTableColumnsData;
}) => {
    const intl = useIntl();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const { handlers, onChange } = useEditorContext<WidgetDatasourceContext>();

    const onHandleSelection = (folders: jFolderList[]) => {
        if (!Array.isArray(folders) || (Array.isArray(folders) && !folders[0])) {
            return;
        }

        setIsOpen(false);

        handlers.handleStart();
        handlers.jamespot.datasource
            .create({
                title: folders[0].title,
                datasourceIdentifier: folders[0].uri,
                datasourceType: DATASOURCE_TYPE.DOC,
            })
            .then((response) => {
                onChange({
                    tableColumnsData: response.result.model.map((el) => {
                        return { name: el.name, isVisible: SUPPORTED_DISPLAY_TYPE.includes(el.type) };
                    }),
                    uri: response.result.uri,
                });
            })
            .catch(handlers.handleCatch)
            .finally(handlers.handleFinally);
    };

    if (type === undefined) {
        return (
            <>
                <JRCButton onClick={() => setIsOpen(true)} variant={'outlined'} minWidth={'100%'} noMargin>
                    {intl.formatMessage({ id: 'WIDGET_Datasource_Fetch_Folder' })}
                </JRCButton>
                {isOpen && (
                    <JRCModalLayout
                        enableClickAwayCloseModal={true}
                        open={isOpen}
                        closeHandler={() => setIsOpen(false)}>
                        <JRCModalContent
                            title={intl.formatMessage({ id: 'WIDGET_Datasource_Fetch_Folder' })}
                            overflow={'scroll'}
                            onClickIconClose={() => setIsOpen(false)}>
                            <JRCFolders
                                loadDocuments={false}
                                allowMultiSelection={false}
                                handlers={handlers.jamespot}
                                onSelectFolder={onHandleSelection}
                            />
                        </JRCModalContent>
                    </JRCModalLayout>
                )}
            </>
        );
    }

    return (
        <>
            {uri && type === DATASOURCE_TYPE.DOC && (
                <DocEditorObject
                    uri={uri}
                    onHandleRemove={() =>
                        onChange({
                            tableColumnsData: [],
                            uri: undefined,
                        })
                    }
                />
            )}
            {uri && model && type === DATASOURCE_TYPE.DOC && (
                <WidgetDatasourceModelView model={model} tableColumnsData={tableColumnsData} onChange={onChange} />
            )}
        </>
    );
};
